import dayjs from 'dayjs';
let utc = require('dayjs/plugin/utc'); // dependent on utc plugin
let timezone = require('dayjs/plugin/timezone');
dayjs.extend(utc)
dayjs.extend(timezone)

const KE = {
  '1001': { text: '', img: 'iphone' }, // iPhone 13 pro
  '1002': { text: '', img: 'power-bank' }, // 充电宝
  '2001': { text: '', img: 'phone-charge' }, // 现金
  '2002': { text: '', img: 'ksh' },
  '3001': { text: '70% Coupon', img: 'per' }, // 免罚息劵
  '3002': { text: '300', img: 'per' },
  '3003': { text: '500', img: 'per' },
  '3004': { text: '50', img: 'limit' }, // 提额劵
  '3005': { text: '100', img: 'limit' },
  '3006': { text: '120', img: 'limit' },
  '3007': { text: '100', img: 'limit' }, // 提额劵
  '3008': { text: '1000', img: 'limit' },
  '3009': { text: '1500', img: 'limit' },
  '3010': { text: '4500', img: 'limit' }, 
  '3011': { text: '200', img: 'repay' }, // 免罚息劵
  '3012': { text: '90% Coupon', img: 'repay' },
  '3013': { text: '50', img: 'repay' }, // 还款劵
  '3014': { text: '100', img: 'repay' },
  '3015': { text: '150', img: 'repay' },
  '3016': { text: '300', img: 'repay' }, // 还款劵
  '3017': { text: '50', img: 'repay' },
  '3018': { text: '60', img: 'repay' },
  '3019': { text: '70', img: 'repay' },
  '3020': { text: '80', img: 'repay' },
  '3021': { text: '70', img: 'repay' },
  '3022': { text: '80', img: 'repay' },
  '4001': { text: '', img: 'no-price' },
  '4002': { text: '', img: 'no-price' },
}
const NG = {
  '1001': { text: '', img: 'iphone' }, // iPhone 13 pro
  '1002': { text: '', img: 'power-bank' }, // 充电宝
  '2001': { text: '5000', img: 'phone-charge' }, // 话费
  '2002': { text: '', img: 'ksh' },
  '3001': { text: '70% Coupon', img: 'per' }, // 免罚息劵
  '3002': { text: '80% Coupon', img: 'per' },
  '3003': { text: '90% Coupon', img: 'per' },
  '3004': { text: '50', img: 'limit' }, // 提额劵
  '3005': { text: '100', img: 'limit' },
  '3006': { text: '120', img: 'limit' },
  '3007': { text: '3000', img: 'limit' }, // 提额劵
  '3008': { text: '3500', img: 'limit' },
  '3009': { text: '4000', img: 'limit' },
  '3010': { text: '4500', img: 'limit' }, 
  '3011': { text: '80% Coupon', img: 'per' }, // 免罚息劵
  '3012': { text: '90% Coupon', img: 'per' },
  '3013': { text: '50', img: 'repay' }, // 还款劵
  '3014': { text: '500', img: 'repay' },
  '3015': { text: '1000', img: 'repay' },
  '3016': { text: '2000', img: 'repay' }, // 还款劵
  '3017': { text: '50', img: 'repay' },
  '3018': { text: '60', img: 'repay' },
  '3019': { text: '70', img: 'repay' },
  '3020': { text: '80', img: 'repay' },
  '3021': { text: '70', img: 'repay' },
  '3022': { text: '80', img: 'repay' },
  '4001': { text: '', img: 'no-price' },
  '4002': { text: '', img: 'no-price' },
}
// ksh为现金 repay还款劵 per包括：limit提额劵 penalty免罚息劵
const MX = {
  '2001': { text: '', img: 'ksh' }, // 现金
  '2002': { text: '', img: 'ksh' },
  '3001': { text: '70% Coupon', img: 'per' }, // 免罚息劵
  '3002': { text: '80% Coupon', img: 'per' },
  '3003': { text: '90% Coupon', img: 'per' },
  '3004': { text: '50', img: 'limit' }, // 提额劵
  '3005': { text: '100', img: 'limit' },
  '3006': { text: '120', img: 'limit' },
  '3007': { text: '40', img: 'repay' }, // 还款劵
  '3008': { text: '50', img: 'repay' },
  '3009': { text: '60', img: 'repay' },
  '3010': { text: '70% Coupon', img: 'per' }, // 免罚息劵
  '3011': { text: '80% Coupon', img: 'per' },
  '3012': { text: '90% Coupon', img: 'per' },
  '3013': { text: '50', img: 'limit' }, // 提额劵
  '3014': { text: '100', img: 'limit' },
  '3015': { text: '120', img: 'limit' },
  '3016': { text: '40', img: 'repay' }, // 还款劵
  '3017': { text: '50', img: 'repay' },
  '3018': { text: '60', img: 'repay' },
  '3019': { text: '70', img: 'repay' },
  '3020': { text: '80', img: 'repay' },
  '3021': { text: '70', img: 'repay' },
  '3022': { text: '80', img: 'repay' },
  '4001': { text: '', img: 'no-price' },
  '4002': { text: '', img: 'no-price' },
}

// 后端返回的code和前端图片映射关系
export const AwardId2ImgMap = {
  kashway: KE,
  ipesa: KE,
  imoney: NG,
  xcredit: NG,
  xfectivo: MX,
  ipeso: MX,
}

// 位置数组 通过这个来抽奖转圈圈
export const ImgPosMap = [[0, 0], [1, 0], [2, 0], [2, 1], [2, 2], [1, 2], [0, 2], [0, 1]];

export const InviteUrlMap = {
  'ipesa': 'https://ipesa.cc/h5/register/ipesa',
  'kashway': 'https://kashway.cc/h5/register/kashway',
}

export const mxLuckType = (type,num) => { // 墨西哥的中间弹窗文案
  if([2001,2002].includes(type)) {
      return `Cash <span>${ num }!</span>` 

  }else if([3001,3002,3003,3010,3011,3012].includes(type)){ // 免罚息券
      return `Has obtenido un cupón que puede ahorrar un <br><span>${ num }</span> de interés.` 

  }else if([3004,3005,3006,3013,3014,3015].includes(type)) { // 提额卷
      return `Has obtenido un cupón de aumento de crédito de <br><span>${ num }</span> pesos.` 

  }else if([3007,3008,3009,3016,3017,3018,3019,3020,3021,3022].includes(type)) { // 还款卷
      return `Has obtenido un cupón de reembolso de <br><span>${ num }</span> pesos.`
      
  }else { // if([4001,4002].includes(type)) 
    return `No prize`
  }
}
export const ngLuckType = (type,num) => {
  if([2002].includes(type)) {
    return `Cash <span>${ num }!</span>` 

  }else if([2001,1002].includes(type)) { // 话费
    return `Congratulations on getting <br><span>${ num }</span>,please contact customer service to redeem.`
    
  }else if([3001,3002,3003,].includes(type)){ // 免罚息券
      return `You have obtained a coupon that can save <br><span>${ num }</span> penalty interest.` 

  }else if([3004,3005,3006,3010,3011,3012,3013,3007,3008,3009,].includes(type)) { // 提额卷
      return `You have received a coupon for increasing loan limit of <br><span>${ num }</span>.` 

  }else if([3014,3015,3016,3017,3018,3019,3020,3021,3022].includes(type)) { // 还款卷
      return `You have received a repayment coupon for <br><span>${ num }</span>`
      
  }else { 
    return `No prize`
  }
}
export const getLuckType = {
  'ipeso': mxLuckType, // 墨西哥
  'xfectivo': mxLuckType,
  'xcredit': ngLuckType, // 尼日利亚
  'imoney': ngLuckType,
  'ipesa': ngLuckType, // 肯尼亚
  'kashway': ngLuckType
}

// 中奖提示文案
const mxHasLuckMsg = { 
  'per': 'Descuento de intereses moratorios', // 免罚息券
  'limit': 'Cupón de aumento de crédito', // 提额卷
  'repay': 'Cupón de reembolso', // 还款卷
}
const ngHasLuckMsg = { 
  'per': 'Penalty Waive Coupon', // 免罚息券
  'limit': 'Limit Increase Coupon', // 提额卷
  'repay': 'Repayment Waive Coupon', // 还款卷
}
export const getHasLuckMsg = {
  'ipeso': mxHasLuckMsg,
  'xfectivo': mxHasLuckMsg,
  'xcredit': ngHasLuckMsg,
  'imoney': ngHasLuckMsg,
  'ipesa': ngHasLuckMsg,
  'kashway': ngHasLuckMsg,
}
// 金币符号
export const sign = {
  'ipeso': '$ ',
  'xfectivo': '$ ',
  'xcredit': '₦ ',
  'imoney': '₦ ',
  'ipesa': 'Ksh ',
  'kashway': 'Ksh ',
}

const timeZone = { // 获取app国家的时区
  'ipeso': 'America/Mexico_City',
  'xfectivo': 'America/Mexico_City',
  'xcredit': 'Africa/Bangui',
  'imoney': 'Africa/Bangui',
  'ipesa': 'Africa/Nairobi',
  'kashway': 'Africa/Nairobi',
}

// 卷的有效日期
export const getValueTime = (couponValidDays,lowerApp) => {
  const currentTime = timeZone[lowerApp] || dayjs.tz.guess()
  let datetime = dayjs.tz(dayjs(),currentTime).format('YYYY-MM-DD')
  const mxActiveTime = dayjs(datetime).add(couponValidDays,'day').format("DD-MM-YYYY") 
  const ngActiveTime = dayjs(datetime).add(couponValidDays,'day').format("YYYY-MM-DD")
  const luckTimeType = {
    'ipeso': mxActiveTime,
    'xfectivo': mxActiveTime,
    'imoney': ngActiveTime,
    'xcredit': ngActiveTime,
    'kashway': ngActiveTime,
    'ipesa': ngActiveTime,
  }
  return couponValidDays ? ( luckTimeType[lowerApp] || ngActiveTime ) : ''
}